import requests from 'api/index';
import { getLanguage } from 'utils/cookies';

const prefixURL = '/employee/memberadmin';
export default {
  getAdminInfo: () =>
    requests.post(`${prefixURL}/rest/v1/emp/readEmployeeByUserId`, {
      userId: '',
    }),
  createTitle: payload => requests.post(`${prefixURL}/rest/v2/comp/code/title/create`, payload),
  deleteTitle: payload => requests.post(`${prefixURL}/rest/v2/comp/code/title/delete`, payload.data),
  createDepartment: payload => requests.post(`${prefixURL}/rest/v2/comp/dept/create`, payload),
  deleteDepartment: payload => requests.post(`${prefixURL}/rest/v2/comp/dept/delete`, payload),
  updatePortalConfig: payload => requests.post(`${prefixURL}/rest/v2/comp/policy/update/ptconf`, payload),
  duplicateIdCheck: payload => requests.post(`${prefixURL}/rest/v1/id/nosession/doublecheck?noSessionPrc=Y`, payload),
  getNationTelCodeList: () =>
    requests.post(`${prefixURL}/rest/v1/pwd/nosession/telcode/list?noSessionPrc=Y&locale=${getLanguage()}`, {}),
  getNewEmp: payload => requests.post(`${prefixURL}/rest/v1/id/nosession/newemp?noSessionPrc=Y`, payload),
  createAccount: payload => requests.post(`${prefixURL}/rest/v1/freemium/nosession/request?noSessionPrc=Y`, payload),
  createOtp: payload => requests.post(`${prefixURL}/rest/v1/id/nosession/link/newemp?noSessionPrc=Y`, payload),
  createInviteEmp: payload => requests.post(`/employee/accountjoin/join`, payload),
  getInviteLink: payload => requests.post(`/employee/accountjoin/${payload}`, {}),
  getTermsPolicy: () => requests.post(`${prefixURL}/rest/v2/terms/policy/version`, {}),
  getNoSessionRegister: () =>
    requests.get(`/employee/empsearch/rest/v1/nosession/property?noSessionPrc=Y&key=ep.empsearch.register`),
  getNoSessionGlobalPosition: () =>
    requests.get(`/employee/empsearch/rest/v1/nosession/property?noSessionPrc=Y&key=ep.global.source.position`),
};
